export const scrollIntoView = <T extends HTMLElement | null>(
  element: T,
  { behavior = 'smooth', ...restOptions }: ScrollIntoViewOptions = {
    behavior: 'smooth',
  },
) => {
  if (!element) return;

  element.scrollIntoView({ behavior, ...restOptions });
};
